import { FirouzehMovafaghiat, Moj, Onb, Sahel } from "assets/files";
import { MetrixEvents } from "containers/services/events.data";
import AuthService from "utils/authService";
import config from "utils/globals";
import { digitsFaToEn } from "@persian-tools/persian-tools";

export const handleLink = (data) => {
  const { action, action_type, link } = data;
  if (action === "EXTERNAL") {
    return link;
  }

  if (action === "INTERNAL") {
    switch (action_type) {
      case "FUNDS":
        return "/funds";
      case "FUND":
        return `/funds/${link}`;
      case "PMAS":
        return "/pma";
      case "FUND_ORDERS":
        return "/fund-orders";
      case "STOCK":
        return `/stocks/${link}`;
      case "USER_PMA":
        return `/user-pma/${link}`;
      case "PMA":
        return `/pma/${link}`;
      case "ORDER":
        return `/fund-order/${link}`;
      case "PRIZE":
        return `/prize`;
      case "REFERRAL":
        return `/referral`;
      case "ONB":
        return `/onboarding`;
      case "CHAT_BOT":
        return `/chatbot`;
      case "BANK":
        return `/card`;
      default:
        break;
    }
  }
  return "/not-found";
};

export const handleLinkTarget = (data) => {
  // return data?.action === "EXTERNAL" ? "_blank" : "_self";
  return "_self";
};

export const fundTypes = (translate, type) => {
  switch (type) {
    case "JointStock":
      return translate("funds-types.joinStock");
    case "FixedIncomeFixedProfit":
      return translate("funds-types.fixedIncomeFixedProfit");
    case "FixedIncome":
      return translate("funds-types.fixedIncome");
    case "Mixed":
      return translate("funds-types.mixed");
    case "MixedProfitDividend":
      return translate("funds-types.mixedProfitDividend");
    case "MixedCharity":
      return translate("funds-types.mixedCharity");
    case "StocksCharity":
      return translate("funds-types.stocksCharity");
    case "ProfitDividendCharity":
      return translate("funds-types.profitDividendCharity");
    case "MarketMarkerFund":
      return translate("funds-types.marketMarkerFund");
    case "FixedIncomeSupporter":
      return translate("funds-types.fixedIncomeSupporter");
    case "ForeignInvestors":
      return translate("funds-types.foreignInvestors");
    case "ETFMixed":
      return translate("funds-types.ETFMixed");
    case "ETFIndex":
      return translate("funds-types.ETFIndex");
    case "CharityWithProfitForecast":
      return translate("funds-types.charityWithProfitForecast");
    case "CharityWithProfitGuarantee":
      return translate("funds-types.charityWithProfitGuarantee");
    case "VentureCapital":
      return translate("funds-types.ventureCapital");
    case "PrivateEquity":
      return translate("funds-types.privateEquity");
    case "Leverage":
      return translate("funds-types.leverage");
    case "Gold":
      return translate("funds-types.gold");
    case "Sector":
      return translate("funds-types.sector");
    default:
      return "-";
  }
};

export const orderTypes = (translate, type) => {
  switch (type) {
    case "BUY":
      return translate("order-types.buy");
    case "SELL":
      return translate("order-types.sell");
    case "WAITING":
    case "PENDING":
      return translate("order-types.waiting");
    case "REJECTED":
      return translate("order-types.rejected");
    case "FAILED":
      return translate("order-types.failed");
    case "CANCELED":
      return translate("order-types.canceled");
    case "DONE":
      return translate("order-types.done");
    case "INQUIRY":
    case "SUCCESS":
      return translate("order-types.success");
    case "EXECUTION_TIME_OUT":
      return translate("order-types.executionTimeOut");
    case "PARTIALLY_FILLED":
      return translate("order-types.waiting");

    default:
      return "-";
  }
};

export const riskTypes = (translate, type) => {
  switch (type) {
    case "WITHOUT":
      return translate("risk-types.without");
    case "HIGH":
      return translate("risk-types.high");
    case "LOW":
      return translate("risk-types.low");

    default:
      return "-";
  }
};

export const transactionsTypes = (translate, type) => {
  switch (type) {
    case "SYSTEM_FAILED":
    case "INVALID":
    case "FAILED":
    case "PSP_NOT_RESPONSE":
    case "REVERSED":
    case "CANCELED":
      return translate("transaction-types.failed");
    case "WAITING":
      return translate("transaction-types.waiting");
    case "SUCCESS":
      return translate("transaction-types.success");
    case "INCREASE":
      return translate("transaction-types.increase");
    case "DECREASE":
      return translate("transaction-types.decrease");
    default:
      return "-";
  }
};
export const chartColors = [
  "#1570EF",
  "#32B8A8",
  "#7AD4DE",
  "#BBBDE6",
  "#4045B2",
  "#21A97A",
  "#FF745A",
  "#007E99",
  "#FFA8A8",
  "#2391FF",
  "#FFC328",
  "#A0DC2C",
  "#946DFF",
  "#626681",
  "#EB4185",
  "#CD8150",
  "#36BCCB",
  "#327039",
  "#803488",
  "#83BC99",
];

export const backgroundColorClasses = [
  "bg-[#1570EF]",
  "bg-[#32B8A8]",
  "bg-[#7AD4DE]",
  "bg-[#BBBDE6]",
  "bg-[#4045B2]",
  "bg-[#21A97A]",
  "bg-[#FF745A]",
  "bg-[#007E99]",
  "bg-[#FFA8A8]",
  "bg-[#2391FF]",
  "bg-[#FFC328]",
  "bg-[#A0DC2C]",
  "bg-[#946DFF]",
  "bg-[#626681]",
  "bg-[#EB4185]",
  "bg-[#CD8150]",
  "bg-[#36BCCB]",
  "bg-[#327039]",
  "bg-[#803488]",
  "bg-[#83BC99]",
];

const createMultiChartData = (input) => {
  const data = [];
  input?.assets?.map((item, index) => {
    return data.push({
      id: index,
      type: item?.fund_name || item?.prx || item?.stock_name,
      value: item?.user_asset_info?.asset_percentage,
      color: backgroundColorClasses[index],
      chartColor: chartColors[index],
      amount: item?.user_asset_info?.asset_value,
    });
  });
  data.sort((a, b) => b.amount - a.amount);

  return data;
};

const createSimpleChartData = (input, typeIndex, chartType) => {
  const data = [];
  input
    ? data.push({
        type: chartType,
        value: input?.total_percentage,
        color: backgroundColorClasses[typeIndex],
        chartColor: chartColors[typeIndex],
        amount: input?.total_value,
      })
    : data.push({
        type: chartType,
        color: backgroundColorClasses[typeIndex],
      });

  return data;
};

export const assetChartDataTransformer = (input, visible = true) => {
  const fundCondition =
    input?.FUND?.total_value !== 0 &&
    input?.PMA?.total_value === 0 &&
    input?.STOCK?.total_value === 0;
  const pmaCondition =
    input?.FUND?.total_value === 0 &&
    input?.PMA?.total_value !== 0 &&
    input?.STOCK?.total_value === 0;
  const stockCondition =
    input?.FUND?.total_value === 0 &&
    input?.PMA?.total_value === 0 &&
    input?.STOCK?.total_value !== 0;

  if ((fundCondition || pmaCondition || stockCondition) && visible) {
    const fundChartData = createMultiChartData(input?.FUND);
    const pmaChartData = createMultiChartData(input?.PMA);
    const stockChartData = createMultiChartData(input?.STOCK);
    return [...fundChartData, ...pmaChartData, ...stockChartData];
  } else {
    const fundChartData = createSimpleChartData(input?.FUND, 0, "صندوق");
    const pmaChartData = createSimpleChartData(input?.PMA, 1, "سبد");
    const stockChartData = createSimpleChartData(input?.STOCK, 2, "سهام");
    return [...fundChartData, ...pmaChartData, ...stockChartData];
  }
};

const dateTransformer = (input, translate) => {
  switch (input) {
    case translate("efficiency-range.one-month"):
      return {
        start_date: config.getOneMonthBefore(),
        end_date: config.getToday(),
      };
    case translate("efficiency-range.three-month"):
      return {
        start_date: config.getThreeMonthBefore(),
        end_date: config.getToday(),
      };
    case translate("efficiency-range.six-month"):
      return {
        start_date: config.getSixMonthBefore(),
        end_date: config.getToday(),
      };
    case translate("efficiency-range.one-year"):
      return {
        start_date: config.getOneYearBefore(),
        end_date: config.getToday(),
      };

    case translate("efficiency-range.daily"):
      return {
        start_date: config.getYesterday(),
        end_date: config.getToday(),
      };

    default:
      return {
        start_date: null,
        end_date: config.getToday(),
      };
  }
};

export const mwrrChartData = (input, efficiencyValue, key, translate, rial) => {
  const data = [];
  const date = dateTransformer(efficiencyValue, translate);

  if (input) {
    input.forEach((item) => {
      const itemDate = new Date(
        config.converToGlobalDate(config.converToPersianDate(item.date))
      );

      const isDateInRange =
        new Date(date?.start_date) <= itemDate &&
        itemDate <= new Date(date?.end_date);

      if (isDateInRange) {
        data.push({
          date: config.converToPersianShortDate(item?.date),
          scales: rial
            ? parseInt(item[key])
            : config.parseFloat(item[key]) * 100,
        });
      }
    });
  }

  return data;
};

export const handleFundPdf = (code) => {
  switch (code) {
    case "12196":
      return Moj;
    case "12180":
      return Sahel;
    case "10789":
      return FirouzehMovafaghiat;
    default:
      return Onb;
  }
};

export const handleFundEfficiencyRange = (data) => {
  const {
    annual_return,
    semi_yearly,
    quarter_return,
    monthly_return,
    daily_return,
  } = data;

  if (annual_return !== null) {
    return config.parseFloat(annual_return);
  } else if (annual_return === null && semi_yearly !== null) {
    return config.parseFloat(semi_yearly);
  } else if (
    annual_return === null &&
    semi_yearly === null &&
    quarter_return !== null
  ) {
    return config.parseFloat(quarter_return);
  } else if (
    annual_return === null &&
    semi_yearly === null &&
    quarter_return === null &&
    monthly_return !== null
  ) {
    return config.parseFloat(monthly_return);
  } else {
    return config.parseFloat(daily_return);
  }
};

export const handleOtpTimerValue = (data) => {
  if (data) {
    const { expire_seconds } = data;
    const minutes = expire_seconds / 60 > 0 ? parseInt(expire_seconds / 60) : 0;
    const seconds = expire_seconds > 59 ? expire_seconds % 60 : expire_seconds;
    return { minutes, seconds };
  } else {
    return { minutes: 1, seconds: 59 };
  }
};

export const getUserData = async () => {
  const user = await AuthService.getUser();
  return user?.profile;
};

export const convertSettingData = (data) => {
  const convertedArray =
    data &&
    Object.entries(data).map(([key, value]) => ({
      type: key,
      ...value,
    }));

  return config.sortArray(convertedArray, "priority");
};

export const provinceDataTransformer = (input) => {
  const data = [];
  input.length &&
    input?.map((item) =>
      data.push({
        label: item?.value,
        value: item?.code,
      })
    );
  return data;
};

export const handleAddressData = (input) => {
  return {
    province_id: digitsFaToEn(`${input?.province}`),
    city_id: digitsFaToEn(`${input?.city}`),
    address: `${digitsFaToEn(`${input?.address}`)} - پلاک ${digitsFaToEn(
      `${input?.tel}`
    )} - واحد ${digitsFaToEn(`${input?.unit}`)}`,
    postal_code: digitsFaToEn(`${input?.postalCode}`),
    is_default: false,
    category: "OTHER",
  };
};

export const handleStagesBankMetrix = async (current, metrix) => {
  const user = await getUserData();
  const attrs = [{ key: "user_id", value: user?.sub }];

  switch (current) {
    case "BASE_INFO":
      return MetrixEvents(metrix, "jkgly", attrs);
    case "CARD":
      return MetrixEvents(metrix, "xlbtt", attrs);
    case "VIDEO":
      return MetrixEvents(metrix, "coqnf", attrs);
    case "ADDRESS":
      return MetrixEvents(metrix, "hfsmy", attrs);
    default:
      break;
  }
};
